import { $$ } from "./Common";


export class Application
{
	private _isMobile: boolean = false;

	constructor()
	{
		window.setInterval(this._onInterval.bind(this), 400);
	}

	private _onInterval(): void
	{
		let mediaWidth = $$.getMediaWidth();
		if (mediaWidth <= 600 && !this._isMobile)
		{
			document.body.classList.add("mobile");
			this._isMobile = true;
		}
		else if (mediaWidth > 600 && this._isMobile)
		{
			document.body.classList.remove("mobile");
			this._isMobile = false;
		}
	}

	public getIsMobile(): boolean
	{
		return this._isMobile;
	}
}

export var $$app = new Application();